var ttq = window.ttq;
export function enableTikTokTracking() {
    ttq && ttq.grantConsent();
}
export function disableTikTokTracking() {
    ttq && ttq.revokeConsent();
}
export function sendTikTokPageViewEvent(productId, productName, value, currency, productDescription) {
    ttq &&
        ttq.track("ViewContent", {
            contents: [
                {
                    content_id: productId,
                    content_name: productName,
                },
            ],
            content_type: "product",
            description: productDescription,
            value: value,
            currency: currency,
        });
}
export function sendTikTokAddToCartEvent(productId, productName, currency, productDescription, quantity, price) {
    ttq &&
        ttq.track("AddToCart", {
            contents: [
                {
                    content_id: productId,
                    content_name: productName,
                    quantity: quantity,
                    price: price,
                },
            ],
            content_type: "product",
            description: productDescription,
            value: price * quantity,
            currency: currency,
        });
}
